"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.InsertItem3D = exports.InsertItem2D = exports.InsertItem = exports.DropItem3D = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _ProjectRow = require("./ProjectRow");
var _api = require("../api");
var _Rule = require("./Rule");
var _RowSlot = require("./RowSlot");
var _controllers = require("../controllers");
var _ICad = require("./ICad");
var InsertItem = /*#__PURE__*/function () {
  function InsertItem() {
    var loader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _controllers.LoaderManager();
    (0, _classCallCheck2["default"])(this, InsertItem);
    this.loader = null;
    this.hasToCenterZoom = true;
    this.substituteItem = false;
    this.loader = loader;
  }
  (0, _createClass2["default"])(InsertItem, [{
    key: "getLoadData",
    value: function getLoadData(el, project) {
      var historyRow = project.getLastHistoryEntry();
      var data = new LoadData(historyRow.catalog, historyRow.currentModel.cmodel, historyRow.currentModel.header, el.item.neutro, el.item.neutrodx, el.side, el.item.load, el.forcedVariants, el.item.firstInsertVar);
      var side = data.lato + '';
      var neutro = null;
      if (side === 'R' && data.neutrodx) {
        neutro = data.neutrodx;
      } else {
        side = 'L';
        neutro = data.neutro;
      }
      data.side = side;
      data.neutro = neutro;
      return data;
    }
  }, {
    key: "setHasToCenterZoom",
    value: function setHasToCenterZoom(center) {
      if (center == false) this.hasToCenterZoom = center;
      return this;
    }
  }, {
    key: "setHasToSubstitute",
    value: function setHasToSubstitute(substitute) {
      this.substituteItem = substitute;
      return this;
    }
  }, {
    key: "getRuleFromItem",
    value: function getRuleFromItem(el, project, iCad) {
      var data = this.getLoadData(el, project);
      this.loadData = data;
      return new _promise["default"](function (resolve, reject) {
        _api.CrulesAPI.loadItem(data.catalog, data.cmodel, data.neutro, data.side, data.forcedVariants, data.variants, function (res) {
          res.rule = new _Rule.Rule(res.rule);
          res.ghost = el.item.ghost;
          res.skipBasket = el.skipBasket;
          resolve(res);
        }, reject);
      });
    }
  }, {
    key: "addItemPrj",
    value: function addItemPrj(res, catalog, header, project) {
      var _this = this;
      return new _promise["default"](function (resolve, reject) {
        if (res.rule.hasForced()) _this.loader.stop();
        _this.forcedResolver.resolve(res.rule, project.getLastHistoryEntry().catalog).then(function (rule) {
          var newRow = project.addNewRow(_ProjectRow.rowTypes.BOX);
          newRow.skipBasket = res.skipBasket || false;
          newRow.ghost = res.ghost || false;
          newRow.initRowFromRule(catalog, header, res.rule);
          newRow.setRule(rule);
          _this.eval(newRow).then(resolve)["catch"](reject);
        })["catch"](reject);
      });
    }
  }, {
    key: "addItemsPrj",
    value: function addItemsPrj(rowRules, catalog, header, project) {
      var _this2 = this;
      return new _promise["default"](function (resolve, reject) {
        var matchArray = [];
        var newRows = [];
        (0, _sort["default"])(rowRules).call(rowRules, function (a, b) {
          if (a.row.father !== null && b.row.father == null) return 1;else if (a.row.father == null && b.row.father !== null) return -1;else {
            return 0;
          }
        });
        (0, _forEach["default"])(rowRules).call(rowRules, function (r) {
          var newRow = project.addDuplicatedRow(_ProjectRow.rowTypes.BOX, r.row);
          newRow.initRowFromRule(catalog, header, r.rule);
          newRow.setRule(r.rule);
          newRow.job = {};
          matchArray.push({
            origin: r.row.uniqueid,
            newest: newRow.uniqueid
          });
          if (r.row.father !== null) {
            newRow.father = JSON.parse((0, _stringify["default"])(r.row.father));
            var match = (0, _find["default"])(matchArray).call(matchArray, function (couple) {
              return couple.origin == r.row.father.idRow;
            });
            if (!match) throw new Error('There is no match between new father and original father');else {
              newRow.father.idRow = match.newest;
            }
          }
          newRows.push(newRow);
          if (newRow.father != null) {
            var fatherRow = project.getRowByUid(newRow.father.idRow);
            fatherRow.clPlacerChilds.push(new _RowSlot.RowSlot(newRow.uniqueid, newRow.father.idSlot, newRow.father.slotType));
          }
        });
        _this2.evalRows(newRows, project).then(function (res) {
          resolve({
            res: res,
            rows: newRows
          });
        })["catch"](reject);
      });
    }
  }, {
    key: "insertItemCad",
    value: function insertItemCad(project) {
      var _this3 = this;
      return new _promise["default"](function (resolve, reject) {
        _this3.iCad.lockCallbacks(true);
        var addLinks = null;
        if (!_this3.substituteItem) {
          addLinks = _this3.iCad.getAddLinksToInsertOn(project);
        }
        _this3.loader.stop();
        if (_this3.resolveAddLinks) {
          _this3.resolveAddLinks.resolve(addLinks).then(function (res) {
            return _this3.resolveInsertItemCad(res, project).then(resolve)["catch"](reject);
          })["catch"](function (err) {
            return _this3.resolveInsertItemCad(err, project).then(resolve)["catch"](reject);
          });
        } else {
          return _this3.resolveInsertItemCad(null, project).then(resolve)["catch"](reject);
        }
      });
    }
  }, {
    key: "resolveInsertItemCad",
    value: function resolveInsertItemCad(res, project) {
      var _this4 = this;
      return new _promise["default"](function (resolve, reject) {
        var after = null;
        if (_this4.substituteItem) {
          after = _this4.iCad.insertBox(project, _this4.substituteItem);
        } else if (res && res.data) {
          after = _this4.iCad.insertBoxByAddLinks(res.data, project);
        } else {
          after = _this4.iCad.insertBox(project, false);
        }
        var newPrjRow = project.getCurrentRow();
        if (after == _ICad.AfterInsertEnum.RE_EVAL_OBJ) {
          _controllers.RowEval.eval(newPrjRow).then(function (res) {
            _this4.iCad.reEvaluateCornerUnit(project.getCurrentRow().uniqueid);
            _this4.iCad.lockCallbacks(false);
            resolve(newPrjRow);
          })["catch"](function (err) {
            console.error(err);
            _this4.iCad.lockCallbacks(false);
            reject();
          });
        } else {
          _this4.iCad.lockCallbacks(false);
          resolve(newPrjRow);
        }
      });
    }
  }, {
    key: "eval",
    value: function _eval(row) {
      var _this5 = this;
      return new _promise["default"](function (resolve, reject) {
        var _a;
        row.reg += ((_a = _this5.loadData) === null || _a === void 0 ? void 0 : _a.firstInsertVar) ? _this5.loadData.firstInsertVar : '';
        _controllers.RowEval.evalRow(row, -1, true).then(function (json) {
          if (json) {
            if (row.nl) row.rule.nl = row.nl;else row.rule.nl = 0;
            if (row.na) row.rule.na = row.na;else row.rule.na = 0;
            if (row.np) row.rule.np = row.np;else row.rule.np = 0;
            if (row.ul) row.rule.ul = row.ul;else row.rule.ul = 0;
            if (row.ua) row.rule.ua = row.ua;else row.rule.ua = 0;
            if (row.up) row.rule.up = row.up;else row.rule.up = 0;
            if (row.l) row.rule.l = row.l;else row.rule.l = 0;
            if (row.a) row.rule.a = row.a;else row.rule.a = 0;
            if (row.p) row.rule.p = row.p;else row.rule.p = 0;
            if (row.rule && row.rule.mergeHeaderRows && json.rule && json.rule.rows) row.rule.mergeHeaderRows(json.rule.rows);
            resolve(json);
          } else {
            reject(new Error('Missing json form eval'));
          }
        })["catch"](reject);
      });
    }
  }, {
    key: "evalPlacer",
    value: function evalPlacer(row, prj) {
      return new _promise["default"](function (resolve, reject) {
        _controllers.RowEval.evalRowPlacer(row, prj, true).then(resolve)["catch"](reject);
      });
    }
  }, {
    key: "evalRows",
    value: function evalRows(rows, prj) {
      var _this6 = this;
      var noEvalRows = (0, _filter["default"])(rows).call(rows, function (r) {
        return r && !r.jeval3ddone && !r.auto && !r.local;
      });
      var row = noEvalRows[0];
      return new _promise["default"](function (resolve, reject) {
        if (row.father == null && !row.clPlacerChilds.length) {
          _this6.eval(row).then(function (data) {
            noEvalRows = (0, _filter["default"])(rows).call(rows, function (r) {
              return r && !r.jeval3ddone && !r.auto && !r.local;
            });
            if (noEvalRows.length > 0) _this6.evalRows(rows, prj).then(resolve)["catch"](reject);else resolve(data);
          })["catch"](reject);
        } else {
          _this6.evalPlacer(row, prj).then(function (data) {
            noEvalRows = (0, _filter["default"])(rows).call(rows, function (r) {
              return r && !r.jeval3ddone && !r.auto && !r.local;
            });
            if (noEvalRows.length > 0) _this6.evalRows(rows, prj).then(resolve)["catch"](reject);else resolve(data);
          })["catch"](reject);
        }
      });
    }
  }, {
    key: "insertItemPrjFromRule",
    value: function insertItemPrjFromRule(res, project) {
      var _this7 = this;
      return new _promise["default"](function (resolve, reject) {
        var historyRow = project.getLastHistoryEntry();
        if (res.rule && res.rule.modoAdd > 0) {
          var placerEvent = null;
          var freePlacerSlot = project.getFreeClassicPlacerSlot();
          var foundFree = false;
          for (var i = 0; i < freePlacerSlot.length && !foundFree; i++) {
            if (freePlacerSlot[i].slotType == res.rule.modoAdd) {
              foundFree = true;
            }
          }
          if (!foundFree) {
            placerEvent = _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT;
          } else {
            placerEvent = _ICad.ClassicPlacerEventsEnum.SELECT_SLOT;
          }
          if (placerEvent == _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT && res.rule.extraEval && res.rule.extraEval.universalPlacer) {
            _this7.addItemPrj(res, historyRow.catalog, historyRow.currentModel.header, project).then(function (res) {
              _this7.afterInsertItemPrj(res, project).then(resolve)["catch"](reject);
            })["catch"](reject);
          } else {
            var status = _this7.afterSelectedPlacer({
              res: res,
              insertPlacer: true,
              placerEvent: placerEvent
            });
            if (status instanceof Error) {
              reject(status);
            }
          }
        } else {
          _this7.addItemPrj(res, historyRow.catalog, historyRow.currentModel.header, project).then(function (res) {
            _this7.afterInsertItemPrj(res, project).then(resolve)["catch"](reject);
          })["catch"](reject);
        }
      });
    }
  }, {
    key: "insert",
    value: function insert(el, project, iCad, forcedVariants, resolveAddLinks) {
      var _this8 = this;
      this.iCad = iCad;
      this.forcedResolver = forcedVariants;
      this.resolveAddLinks = resolveAddLinks;
      return new _promise["default"](function (resolve, reject) {
        try {
          project.setEnvWall(iCad.getEnvWallJson());
        } catch (err) {
          reject(err);
        }
        if (_this8.loader && _this8.loader.start) _this8.loader.start();
        _this8.getRuleFromItem(el, project, iCad).then(function (res) {
          _this8.insertItemPrjFromRule(res, project).then(resolve)["catch"](reject);
        })["catch"](reject);
      });
    }
  }]);
  return InsertItem;
}();
exports.InsertItem = InsertItem;
var InsertItem3D = /*#__PURE__*/function (_InsertItem) {
  (0, _inherits2["default"])(InsertItem3D, _InsertItem);
  var _super = (0, _createSuper2["default"])(InsertItem3D);
  function InsertItem3D(loader) {
    (0, _classCallCheck2["default"])(this, InsertItem3D);
    return _super.call(this, loader);
  }
  (0, _createClass2["default"])(InsertItem3D, [{
    key: "afterSelectedPlacer",
    value: function afterSelectedPlacer(res) {
      var response = null;
      switch (res.placerEvent) {
        case _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT:
          response = new Error('No free slot');
          break;
        case _ICad.ClassicPlacerEventsEnum.SELECT_SLOT:
          this.iCad.selectPlacerSlot(res);
          break;
      }
      this.loader.stop();
      return response;
    }
  }, {
    key: "afterInsertItemPrj",
    value: function afterInsertItemPrj(res, prj) {
      var _this9 = this;
      return new _promise["default"](function (resolve, reject) {
        _this9.insertItemCad(prj).then(function (data) {
          _this9.redraw3D(prj).then(function () {
            resolve(res);
          })["catch"](reject);
        })["catch"](reject);
      });
    }
  }, {
    key: "redraw3D",
    value: function redraw3D(prj) {
      var _this10 = this;
      return new _promise["default"](function (resolve, reject) {
        try {
          _this10.iCad.drawAll(false, prj, resolve, _this10.loader.progressWithTotal, _this10.hasToCenterZoom);
        } catch (err) {
          reject(err);
        }
      });
    }
  }]);
  return InsertItem3D;
}(InsertItem);
exports.InsertItem3D = InsertItem3D;
var InsertItem2D = /*#__PURE__*/function (_InsertItem2) {
  (0, _inherits2["default"])(InsertItem2D, _InsertItem2);
  var _super2 = (0, _createSuper2["default"])(InsertItem2D);
  function InsertItem2D(loader) {
    (0, _classCallCheck2["default"])(this, InsertItem2D);
    return _super2.call(this, loader);
  }
  (0, _createClass2["default"])(InsertItem2D, [{
    key: "afterSelectedPlacer",
    value: function afterSelectedPlacer(res) {
      var response = null;
      switch (res.placerEvent) {
        case _ICad.ClassicPlacerEventsEnum.NO_FREE_SLOT:
          response = new Error('No free slot');
          break;
        case _ICad.ClassicPlacerEventsEnum.SELECT_SLOT:
          response = new Error('No placer in 2D');
          break;
      }
      this.loader.stop();
      return response;
    }
  }, {
    key: "afterInsertItemPrj",
    value: function afterInsertItemPrj(res, project) {
      var _this11 = this;
      return new _promise["default"](function (resolve, reject) {
        _this11.insertItemCad(project).then(resolve)["catch"](reject);
      });
    }
  }]);
  return InsertItem2D;
}(InsertItem);
exports.InsertItem2D = InsertItem2D;
var DropItem3D = /*#__PURE__*/function (_InsertItem3D) {
  (0, _inherits2["default"])(DropItem3D, _InsertItem3D);
  var _super3 = (0, _createSuper2["default"])(DropItem3D);
  function DropItem3D(loader, pos) {
    var _this12;
    (0, _classCallCheck2["default"])(this, DropItem3D);
    _this12 = _super3.call(this, loader);
    _this12.position = null;
    _this12.position = pos;
    return _this12;
  }
  (0, _createClass2["default"])(DropItem3D, [{
    key: "afterInsertItemPrj",
    value: function afterInsertItemPrj(res, prj) {
      var _this13 = this;
      return new _promise["default"](function (resolve, reject) {
        _this13.iCad.insertBoxFreePosition(prj, _this13.position.pos.x, _this13.position.pos.y, _this13.position.pos.z, _this13.position.axz);
        var row = prj.rows[prj.rows.length - 1];
        row.pl = _this13.position.pos.x;
        row.pa = _this13.position.pos.y;
        row.pp = _this13.position.pos.z;
        row.axz = _this13.position.axz;
        _this13.redraw3D(prj).then(function () {
          resolve(res);
        })["catch"](reject);
      });
    }
  }]);
  return DropItem3D;
}(InsertItem3D);
exports.DropItem3D = DropItem3D;
var LoadData = /*#__PURE__*/(0, _createClass2["default"])(function LoadData(catalog, cod, header, neutro, neutrodx, side, load, forcedVariants, firstInsertVar) {
  (0, _classCallCheck2["default"])(this, LoadData);
  this.catalog = catalog;
  this.cmodel = cod;
  this.variants = header;
  this.item = neutro;
  this.neutro = neutro;
  this.neutrodx = neutrodx;
  this.lato = side;
  this.load = load;
  this.firstInsertVar = firstInsertVar;
  this.side = side;
  this.forcedVariants = forcedVariants;
});
//# sourceMappingURL=InsertItem.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/InsertItem.js
// module id = 475
// module chunks = 142